import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

//import { mode } from 'template/material-theme'

const useStyles = makeStyles((theme: Theme) => createStyles({

  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

  modalRoot: {
    position: 'fixed',
    zIndex: 1300,
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  legacyModal: {
    position: 'relative',
  },

  legacyStage: {
    position: 'relative',
  },

  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
    color: theme.palette.text.primary,
    backgroundColor: 'rgba(255, 255, 255, .92)',
    '&:hover': {
      backgroundColor: 'white',
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.text.primary}`,
      outlineOffset: 2,
    },
  },

  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

  carouselWrapper: {
    position: 'relative',
    userSelect: 'none',

    width: '100%',
    maxWidth: 'calc(100vw - 32px)', // TODO: Wo kommen die 32px her?

    [theme.breakpoints.up('sm')]: {
      maxWidth: 'calc(100vw - 75px)', // TODO: Wo kommen die 75px her?
    },

    '& .swiper': {
      '& .swiper-button-prev, & .swiper-button-next': {
        '&:after': {
          color: theme.palette.primary.light,
          userSelect: 'none',
        },
      },
    },
  },

  imageSwiper: {
    height: 'calc(100vh - 85px)',
    userSelect: 'none',
    '--swiper-navigation-color': theme.palette.text.primary,
    '--swiper-theme-color': theme.palette.text.primary,
    '& .swiper-slide, & .swiper-zoom-container': {
      userSelect: 'none',
      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
  },

  fallbackImage: {
    height: 'calc(100vh - 85px)',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    userSelect: 'none',

    '& > img': {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    },
  },

  imageSlide: {
    position: 'relative',
  },

  fullscreenModal: {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    paddingTop: 'env(safe-area-inset-top)',
    paddingBottom: 'env(safe-area-inset-bottom)',
    overflow: 'hidden',
    outline: 0,
    backgroundColor: 'rgba(9, 9, 9, .74)',
    touchAction: 'none',
  },

  fullscreenToolbar: {
    flex: '0 0 58px',
    minHeight: 58,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: theme.spacing(0, 1.25, 0, 2),
    color: '#fff',
    background: 'linear-gradient(180deg, rgba(0, 0, 0, .62), rgba(0, 0, 0, .28))',
    zIndex: 3,
  },

  imageCounter: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: 0,
    textShadow: '0 1px 2px rgba(0, 0, 0, .35)',
  },

  fullscreenControls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(.75),
  },

  fullscreenIconButton: {
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, .32)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, .46)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, .42)',
      backgroundColor: 'rgba(0, 0, 0, .18)',
    },
    '&:focus-visible': {
      outline: '2px solid rgba(255, 255, 255, .9)',
      outlineOffset: 2,
    },
  },

  fullscreenStage: {
    flex: '1 1 auto',
    minHeight: 0,
    width: '100%',
    display: 'flex',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },

  fullscreenImageSwiper: {
    width: '100%',
    height: '100%',
    userSelect: 'none',
    '--swiper-navigation-color': '#111',
    '--swiper-theme-color': '#111',

    '& .swiper-button-prev, & .swiper-button-next': {
      width: 42,
      height: 42,
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, .82)',
      boxShadow: '0 5px 16px rgba(0, 0, 0, .14)',

      '&:after': {
        fontSize: 20,
        fontWeight: 700,
      },
    },

    '& .swiper-slide': {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      userSelect: 'none',
    },

    '& .swiper-zoom-container': {
      width: '100%',
      height: '100%',
      userSelect: 'none',
      touchAction: 'none',
      cursor: 'zoom-in',

      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        backgroundColor: '#fff',
      },
    },
  },

}))

export default useStyles
